import { lazy } from "react"
import type { FC, LazyExoticComponent, ReactElement } from "react"

import { ModalContainer } from "@/3514/components"
import { EModalId } from "@/3514/store/modal"

const Container: LazyExoticComponent<FC> = lazy(
    (): Promise<{ default: FC }> => import("./post-session.modal.container")
)

const Modal: FC = (): ReactElement => <ModalContainer modalId={EModalId.PostSession} container={Container} />

export { Modal as PostSessionModal }
